import axios from '@axios'

export const state = {
  reports: {},
}

export const getters = {
  allRecipientReports: (state) => state.reports,
}

export const mutations = {
  GET_REPORTS: (state, data) => {
    if (!data) {
      state.reports = {}
      return false
    }
    state.reports = data
  },
}

export const actions = {
  async getCampaignReports({ commit }) {
    return axios.get('/sms/dashboard/campaigns')
  },

  async getRecipientReports({ commit }) {
    return axios.get('/sms/dashboard/traffic')
  },

  async theRecipientReports({ commit }) {
    await axios
      .get('/sms/bashboard/transaction')
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_REPORTS', resp.data)
        }
      })
      .catch(() => {
        commit('GET_REPORTS', null)
      })
  },
}
